/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BulkImportFacilityServiceAreasResponseErrorsInner } from './BulkImportFacilityServiceAreasResponseErrorsInner';
import {
    BulkImportFacilityServiceAreasResponseErrorsInnerFromJSON,
    BulkImportFacilityServiceAreasResponseErrorsInnerFromJSONTyped,
    BulkImportFacilityServiceAreasResponseErrorsInnerToJSON,
} from './BulkImportFacilityServiceAreasResponseErrorsInner';

/**
 * 
 * @export
 * @interface BulkImportFacilityServiceAreasResponse
 */
export interface BulkImportFacilityServiceAreasResponse {
    /**
     * 
     * @type {number}
     * @memberof BulkImportFacilityServiceAreasResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof BulkImportFacilityServiceAreasResponse
     */
    succeeded: number;
    /**
     * 
     * @type {number}
     * @memberof BulkImportFacilityServiceAreasResponse
     */
    failed: number;
    /**
     * 
     * @type {Array<BulkImportFacilityServiceAreasResponseErrorsInner>}
     * @memberof BulkImportFacilityServiceAreasResponse
     */
    errors: Array<BulkImportFacilityServiceAreasResponseErrorsInner>;
}

/**
 * Check if a given object implements the BulkImportFacilityServiceAreasResponse interface.
 */
export function instanceOfBulkImportFacilityServiceAreasResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "succeeded" in value;
    isInstance = isInstance && "failed" in value;
    isInstance = isInstance && "errors" in value;

    return isInstance;
}

export function BulkImportFacilityServiceAreasResponseFromJSON(json: any): BulkImportFacilityServiceAreasResponse {
    return BulkImportFacilityServiceAreasResponseFromJSONTyped(json, false);
}

export function BulkImportFacilityServiceAreasResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkImportFacilityServiceAreasResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': json['total'],
        'succeeded': json['succeeded'],
        'failed': json['failed'],
        'errors': ((json['errors'] as Array<any>).map(BulkImportFacilityServiceAreasResponseErrorsInnerFromJSON)),
    };
}

export function BulkImportFacilityServiceAreasResponseToJSON(value?: BulkImportFacilityServiceAreasResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'succeeded': value.succeeded,
        'failed': value.failed,
        'errors': ((value.errors as Array<any>).map(BulkImportFacilityServiceAreasResponseErrorsInnerToJSON)),
    };
}

